import styled, { keyframes } from "styled-components";

export const StyledEnter = styled.section`
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 1rem 0vw 2rem 0vw;
  `,
  growIn = keyframes`
0%{transform:scale(0.1); opacity:0;}
80%{ transform:scale(1.3);opacity:0.9;}
95%{ transform:scale(0.90);opacity:1;}
100% {transform:scale(1);}
`,
  BoldText = styled.h1`
    padding: 0;
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #083f88;

    @media only screen and (min-width: 600px) {
      font-size: 20px;
    }
    @media only screen and (min-width: 725px) {
      font-size: 24px;
      text-align: center;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 2.4vw;
    }
  `,
  SubText = styled.p`
    padding: 0;
    margin: 0;
    font-size: 15px;
    line-height: 2;
    color: #083F88;
    padding: 1vw 0vw 1vw 0vw;
    text-align: center;
    font-weight: 300;
    @media only screen and (min-width: 600px) {
      text-align: center;
      padding: 0.5vw 0vw 0.5vw 0vw;
      line-height: 1;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.5vw;
    }
  `,
  Header = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
  `,
  BoxRow = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media only screen and (min-width: 475px) {
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
      justify-content: center;
    }
    @media only screen and (min-width: 1000px) {
      flex-direction: row;
      width: 50%;
      justify-content: center;
    }
  `,
  Row = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    margin-top: 0vw;
    height: 100%;
    flex-flow: column nowrap;
    padding: 1.5rem 0rem 0rem 0rem;
    @media (min-width: 475px) {
      flex-flow: row wrap;
      align-items: flex-start;
    }
  `,
  Column = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    width: 100%;

    @media only screen and (min-width: 1000px) {
    }
  `,
  BoldTitle = styled.h4`
    padding: 0;
    margin: 0;
    font-size: 25.2061px;
    text-align: center;
    line-height: 1.5;
    display: flex;
    font-weight: 600;
    justify-content: center;
    align-items: flex-start;
    color: #083F88;
    font-family:'Poppins';
    padding: ${({ circleAnimation }) =>
      circleAnimation ? "3.5vw 0vw 1.5vw 0vw" : "8rem 0rem 1vw 0rem"};
    @media (min-width: 475px) {
      font-size: 20px;
      padding: ${({ circleAnimation }) =>
        circleAnimation ? "1vw" : "12vw 0rem 1vw 0rem"};
    }
    @media only screen and (min-width: 1000px) {
      font-size: 2.2vw;
    }
  `,
  Subtitle = styled.p`
    padding: 0;
    margin: 0;
    line-height: 1.3;
    font-size: 15px;
    width: 10rem;
    text-align: center;
    font-weight: 400;
    color: #444444;
    padding: 0vw 0vw 1vw 0vw;
    @media (min-width: 475px) {
      font-size: 14px;
      padding: 0;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.25vw;
      width: 16vw;
    }
  `,
  Icon = styled.a`
    padding: 0;
    margin: 0;
    text-decoration: none;
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
    margin-top: ${({ top = 0 }) => top}rem;
    margin-left: ${({ left = 0 }) => left }rem;
    display: flex;
    z-index: 1;
    flex-flow: column;
    position: absolute;
    justify-content: center;
    align-items: center;
    background: url(${({ icon }) => icon}) no-repeat center;
    // background-size: cover;
     animation: ${growIn} 0.35s ease-in 0s 1;
     background-color: #ffffff;
     transition: box-shadow 0.25s;
    box-sizing: border-box;
    // box-shadow: inset 0px -10px 10px rgba(59, 89, 152, 0.5),
    // inset 0px 4px 5px rgba(255, 255, 255, 0.12);
    &:hover {
      box-shadow: inset 0px -10px 10px rgba(255, 255, 255, 0.12),
      inset 0px 4px 5px rgba(59, 89, 152, 0.5);
      border:3px solid #29A9E1;
    }
    @media only screen and (min-width: 600px) {
      margin-top: ${({ top = 0 }) => top }rem;
      margin-left: ${({ left = 0 }) => left }rem;
    }
    @media only screen and (min-width: 1000px) {
      height: 4vw;
      width: 4vw;
      margin-top: ${({ top = 0 }) => top * 1.5}vw;
      margin-left: ${({ left = 0 }) => left * 1.5}vw;
    }
    @media only screen and (min-width: 1500px) {
      height: 4vw;
      width: 4vw;
      margin-top: ${({ top = 0 }) => top * 1.4}vw;
      margin-left: ${({ left = 0 }) => left * 1.4}vw;
    }
  `,
  Bar = styled.div`
    padding: 0;
    margin: 0;
    transform: rotate(${({ deg = 0 }) => deg}deg);
    &::after {
      padding: 0;
      margin: 0;
      content: "";
      margin-left: -1.33px;
      position: absolute;
      width: 3px;
      background: #3288c0;
      margin-top: 1.15rem;
      z-index: -1;
      height: 3vw;
      @media only screen and (min-width: 1000px) {
        margin-top: 1.75vw;
        width: 4px;
      }
      @media only screen and (min-width: 1500px) {
      
        width: 5px;
      }
    }
  `,
  IconBox = styled.div`
    padding: 0;
    margin: 0;
    z-index: 1;
    display: ${({ toggle }) => (toggle ? "flex" : "none")};
    justify-content: center;
    align-items: flex-start;
  `;
